(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1837],{

/***/ 7725:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/thread/handwritten-web-development-notes",
      function () {
        return __webpack_require__(7334);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "meta": function() { return /* binding */ meta; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _mdx_js_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1151);
/* harmony import */ var _layouts_TwitterThreadLayout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1075);
/* harmony import */ var _components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6833);
/*@jsxRuntime automatic @jsxImportSource react*/ 



const meta = {
    url: "https://devsforgood.com/thread/handwritten-web-development-notes",
    title: "Handwritten web development notes",
    description: "My handwritten Web Development notes ✍️\n\n\uD83E\uDDF5\uD83D\uDC47",
    image: "/covers/threads/handwritten-web-development-notes.png",
    author: "Pratham"
};
const MDXLayout = (param)=>{
    let { children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layouts_TwitterThreadLayout__WEBPACK_IMPORTED_MODULE_1__/* .TwitterThreadLayout */ .T, {
        meta: meta,
        children: children
    });
};
function _createMdxContent(props) {
    const _components = Object.assign({
        p: "p",
        ol: "ol",
        li: "li"
    }, (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_3__/* .useMDXComponents */ .ah)(), props.components);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadAuthor */ .vI, {
                name: "Pratham",
                username: "Prathkum",
                avatarUrl: "/avatars/Prathkum.png"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadOriginalUrl */ .KN, {
                url: "https://twitter.com/Prathkum/status/1384780558165680135"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlockFirst */ .Iq, {
                image: "undefined",
                children: [
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                        children: "My handwritten Web Development notes ✍️"
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                        children: "\uD83E\uDDF5\uD83D\uDC47"
                    })
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "/images/handwritten-web-development-notes-1.png",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.ol, {
                    children: [
                        "\n",
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.li, {
                            children: "CSS selectors ☑️"
                        }),
                        "\n"
                    ]
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "/images/handwritten-web-development-notes-2.png",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.ol, {
                    start: "2",
                    children: [
                        "\n",
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.li, {
                            children: "Some important CSS Pseudo classes \uD83D\uDD2F"
                        }),
                        "\n"
                    ]
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "/images/handwritten-web-development-notes-3.png",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.ol, {
                    start: "3",
                    children: [
                        "\n",
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.li, {
                            children: "Box model ◻️▫️▪️\uD83D\uDD32\uD83D\uDD33"
                        }),
                        "\n"
                    ]
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "/images/handwritten-web-development-notes-4.png",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.ol, {
                    start: "4",
                    children: [
                        "\n",
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.li, {
                            children: "Display property ➖"
                        }),
                        "\n"
                    ]
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "/images/handwritten-web-development-notes-5.png",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.ol, {
                    start: "5",
                    children: [
                        "\n",
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.li, {
                            children: "Justify-content and align-content explained ⬅️⬇️"
                        }),
                        "\n"
                    ]
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "/images/handwritten-web-development-notes-6.png",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.ol, {
                    start: "6",
                    children: [
                        "\n",
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.li, {
                            children: "Align-items and align-self explained \uD83D\uDCCA"
                        }),
                        "\n"
                    ]
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "/images/handwritten-web-development-notes-7.png",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.ol, {
                    start: "7",
                    children: [
                        "\n",
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.li, {
                            children: "Axes of a layout container ⬆️➡️"
                        }),
                        "\n"
                    ]
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "/images/handwritten-web-development-notes-8.png",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.ol, {
                    start: "8",
                    children: [
                        "\n",
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.li, {
                            children: "z-index - stacking order of elements \uD83C\uDFD7️"
                        }),
                        "\n"
                    ]
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "/images/handwritten-web-development-notes-9.png",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.ol, {
                    start: "9",
                    children: [
                        "\n",
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.li, {
                            children: "Give your element a 3D look wit1h CSS perspective property \uD83D\uDC40\uD83D\uDD76️"
                        }),
                        "\n"
                    ]
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "/images/handwritten-web-development-notes-10.png",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.ol, {
                    start: "10",
                    children: [
                        "\n",
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.li, {
                            children: "Alignment in CSS \uD83D\uDDC4️"
                        }),
                        "\n"
                    ]
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "/images/handwritten-web-development-notes-11.png",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.ol, {
                    start: "11",
                    children: [
                        "\n",
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.li, {
                            children: "Quick start guide to Grid layout \uD83E\uDDEE"
                        }),
                        "\n"
                    ]
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "/images/handwritten-web-development-notes-12.png",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.ol, {
                    start: "12",
                    children: [
                        "\n",
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.li, {
                            children: "Position property CSS ⏹️"
                        }),
                        "\n"
                    ]
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "/images/handwritten-web-development-notes-13.png",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.ol, {
                    start: "13",
                    children: [
                        "\n",
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.li, {
                            children: "Grid cheat sheet \uD83D\uDCC3"
                        }),
                        "\n"
                    ]
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "/images/handwritten-web-development-notes-14.png",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.ol, {
                    start: "14",
                    children: [
                        "\n",
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.li, {
                            children: "Flexbox cheat sheet \uD83D\uDCC4"
                        }),
                        "\n"
                    ]
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "/images/handwritten-web-development-notes-15.png",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.ol, {
                    start: "15",
                    children: [
                        "\n",
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.li, {
                            children: "animation-timing-function \uD83D\uDCC9\uD83D\uDCC8"
                        }),
                        "\n"
                    ]
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "/images/handwritten-web-development-notes-16.png",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.ol, {
                    start: "16",
                    children: [
                        "\n",
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.li, {
                            children: 'Don\'t use "solid" border always \uD83D\uDDBC️'
                        }),
                        "\n"
                    ]
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "/images/handwritten-web-development-notes-17.png",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.ol, {
                    start: "17",
                    children: [
                        "\n",
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.li, {
                            children: "Git workflow \uD83C\uDF0A\uD83D\uDCF2"
                        }),
                        "\n"
                    ]
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "/images/handwritten-web-development-notes-18.png",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.ol, {
                    start: "18",
                    children: [
                        "\n",
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.li, {
                            children: "JavaScript Array methods cheat sheet Ⓜ️"
                        }),
                        "\n"
                    ]
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "/images/handwritten-web-development-notes-19.png",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.ol, {
                    start: "19",
                    children: [
                        "\n",
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.li, {
                            children: "JavaScript Date methods \uD83D\uDCC5\uD83D\uDDD3️"
                        }),
                        "\n"
                    ]
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "/images/handwritten-web-development-notes-20.png",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.ol, {
                    start: "20",
                    children: [
                        "\n",
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.li, {
                            children: "What is a functions \uD83E\uDDE9"
                        }),
                        "\n"
                    ]
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "/images/handwritten-web-development-notes-21.png",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.ol, {
                    start: "21",
                    children: [
                        "\n",
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.li, {
                            children: "Arrow functions ➡️"
                        }),
                        "\n"
                    ]
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "/images/handwritten-web-development-notes-22.png",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.ol, {
                    start: "22",
                    children: [
                        "\n",
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.li, {
                            children: "Document Object Model \uD83C\uDF33"
                        }),
                        "\n"
                    ]
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "/images/handwritten-web-development-notes-23.png",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.ol, {
                    start: "23",
                    children: [
                        "\n",
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.li, {
                            children: "addEventListener method \uD83C\uDFA4"
                        }),
                        "\n"
                    ]
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "/images/handwritten-web-development-notes-24.png",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.ol, {
                    start: "24",
                    children: [
                        "\n",
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.li, {
                            children: "Font shorthand property \uD83D\uDD20"
                        }),
                        "\n"
                    ]
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "/images/handwritten-web-development-notes-25.png",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.ol, {
                    start: "25",
                    children: [
                        "\n",
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.li, {
                            children: "justify-items | align-items | justify-content | align-content \uD83D\uDFE5\uD83D\uDFE6◻️▪️"
                        }),
                        "\n"
                    ]
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "/images/handwritten-web-development-notes-26.png",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.ol, {
                    start: "26",
                    children: [
                        "\n",
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.li, {
                            children: "Array methods [◽◾◽◾]"
                        }),
                        "\n"
                    ]
                })
            })
        ]
    });
}
function MDXContent() {
    let props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MDXLayout, Object.assign({}, props, {
        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_createMdxContent, props)
    }));
}
/* harmony default export */ __webpack_exports__["default"] = (MDXContent);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4500,5675,2361,8411,9774,2888,179], function() { return __webpack_exec__(7725); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);